import { render, staticRenderFns } from "./registration-container.vue?vue&type=template&id=72ea61e5&scoped=true&"
import script from "./registration-container.vue?vue&type=script&lang=js&"
export * from "./registration-container.vue?vue&type=script&lang=js&"
import style0 from "./registration-container.vue?vue&type=style&index=0&id=72ea61e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ea61e5",
  null
  
)

export default component.exports